import * as React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

type Props = {
    title: string;
    icon: React.ReactNode;
    iconBackgroundColor?: React.CSSProperties['backgroundColor'];
    iconSize: 'sm' | 'md';
};

const StyIconAndTextContainer = styled(Box, {
    name: 'StyIconAndTextContainer',
})({
    display: 'flex',
    alignItems: 'center',
});

const StyIconCircle = styled(Box, {
    name: 'StyIconCircle',
    shouldForwardProp: (prop) => prop !== 'backgroundColor' && prop !== 'size',
})<{
    backgroundColor: React.CSSProperties['backgroundColor'];
    size: 'sm' | 'md';
}>(({ theme, backgroundColor, size }) => ({
    marginRight: theme.spacing(1.5),
    display: 'flex',
    color: theme.palette.common.white,
    backgroundColor: backgroundColor ?? theme.palette.primary.main,
    borderRadius: size === 'sm' ? theme.spacing(2) : theme.spacing(1),
    width: size === 'sm' ? theme.spacing(3) : theme.spacing(5),
    height: size === 'sm' ? theme.spacing(3) : theme.spacing(5),
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
        fontSize: size === 'sm' ? theme.spacing(2) : theme.spacing(3),
    },
}));

const StyTitle = styled(Typography, {
    name: 'StyTitle',
})({
    // creates ellipsis but on 2 lines
    // see https://css-tricks.com/almanac/properties/l/line-clamp/
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    // we use max height for old Firefox version that do not support line clamp
    maxHeight: '40px',
    wordBreak: 'break-word',
    lineHeight: '20px',
});

export const GenericCardHeader = ({
    title,
    icon,
    iconBackgroundColor = undefined,
    iconSize,
}: Props) => {
    return (
        <StyIconAndTextContainer>
            <StyIconCircle
                backgroundColor={iconBackgroundColor}
                size={iconSize}
            >
                {icon}
            </StyIconCircle>
            <Tooltip title={title} enterDelay={500}>
                <StyTitle variant="body1SemiBold">{title}</StyTitle>
            </Tooltip>
        </StyIconAndTextContainer>
    );
};
